import React from "react"

import { Dots } from "./_inlineEllipsisStyle"

function InlineEllipsis() {
  return <Dots />
}

export default InlineEllipsis